// extracted by mini-css-extract-plugin
export default {"container":"item_container__2NEju","list":"item_list__Driv3","item":"item_item__YJU9c","title":"item_title__ALM8+","value":"item_value__v4Mzv","actions":"item_actions__PqOWV"};